import styled from "styled-components";
import { media } from "../../../../utils";

export const ContainerGrupo = styled.div({
  display: "flex",
  flexWrap: "wrap",
  span: {
    flexBasis: "120px",
    textAlign: "center",
  },
});

export default styled.div`
  ${media.md()} {
    width: 50%;
  }
`;
